module.exports = __webpack_public_path__ + "63ca65077cd7aabcc0de4f74892695e6.svg";